import React from 'react';
import Timestamp from 'react-timestamp';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ChatIcon from '@material-ui/icons/Chat';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { getTimeAsString } from '../../services/DateService';
import FeedbackBadIcon from '../Icon/FeedbackBadIcon';
import FeedbackGoodIcon from '../Icon/FeedbackGoodIcon';
import FeedbackNeutralIcon from '../Icon/FeedbackNeutralIcon';
import KobooButton from '../Layout/KobooButton';
import StringService from '../../services/StringService';

export const useStyles = makeStyles(() => (
  {
    icon: {
      width: '30px',
      height: '30px',
      margin: '-10px',
    },
    button: {
      padding: '3px 15px !important',
      width: 'auto !important',
    },
    smallButton: {
      width: '41px !important',
      minWidth: '40px',
      padding: '8px 8px !important'
    },
  }
));

export const FeedbackRow = (props) => {

  const {
    feedback,
    showFeedback,
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
  return (
    <TableRow
      hover
      tabIndex={-1}
    >
      <TableCell>
        <Timestamp
          format="full"
          twentyFourHour
          time={feedback.user_feedback_date}
        />
      </TableCell>
      <TableCell>
        {feedback.start_site_name}
      </TableCell>
      <TableCell>
        {StringService.formatClientName(feedback.user_lastname, feedback.user_firstname)}
      </TableCell>
      <TableCell style={{ wordBreak: 'break-all' }}>
        {feedback.user_email}
      </TableCell>
      <TableCell>
        <Timestamp
          format="full"
          twentyFourHour
          time={feedback.start_date}
        />
      </TableCell>
      <TableCell>
        {getTimeAsString(feedback.duration)}
      </TableCell>
      <TableCell>
        {feedback.bike_number}
      </TableCell>
      <TableCell>
        <Grid
          container
          justifyContent={'flex-start'}
          direction={'row'}
          spacing={2}
          alignItems={'center'}
          wrap={'nowrap'}
        >
          <Grid item style={{
            paddingBottom: 0,
            paddingTop: (feedback.user_feedback !== null && feedback.user_feedback !== '') ? 0 : '5px',
          }}>
            {feedback.user_feedback_opinion === 'bad'
            && <FeedbackBadIcon className={classes.icon} />}
            {feedback.user_feedback_opinion === 'neutral'
            && <FeedbackNeutralIcon className={classes.icon} />}
            {feedback.user_feedback_opinion === 'good'
            && <FeedbackGoodIcon className={classes.icon} />}
          </Grid>
          <Grid item style={{ paddingBottom: 0, paddingTop: 0 }}>
            {feedback.user_feedback !== null && feedback.user_feedback !== ''
            && <KobooButton
              className={matchesLg ? classes.button : classes.smallButton}
              onClick={() => showFeedback(feedback.user_feedback, feedback.user_feedback_opinion)}
            >
              {matchesXl && <Typography variant={'button'} noWrap>Lire l'avis</Typography>}
              {matchesLg && !matchesXl && <Typography variant={'button'} noWrap>Avis</Typography>}
              {!matchesLg && <ChatIcon/>}
            </KobooButton>}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default FeedbackRow;



// WEBPACK FOOTER //
// ./src/components/Feedback/FeedbackRow.jsx